<template>
  <div class="full-height">
    <div
      width="100%"
      rounded="0"
      class="full-height"
      id="manager"
      :class="!isMobile ? 'd-flex flex-column' : ''"
    >
      <!-- Header card/row -->
      <Header
        title="Communications"
        icon="mdi-email"
        iconColor="brand-orange"
        class="mb-5"
        :class="!isMobile ? 'mx-6' : 'mx-0'"
        :elevation="0"
        :showSearch="true"
        @update-search="handleSearchValueChange"
      />
      <!-- Options row -->
      <v-row
        class="d-flex justify-space-between flex-grow-1"
        :style="isMobile ? {} : { 'max-height': '60%' }"
        :class="{
          'flex-column': isMobile,
          'px-6': !isMobile,
        }"
      >
        <v-col :cols="isMobile ? '12' : '4'" class="card-col">
          <v-card :style="{ height: 'fit-content' }" class="mb-3" elevation="0" @click="loadWizard">
            <div class="pa-3 d-flex flex-column justify-center">
              <div
                class="d-flex justify-space-between align-center pt-4 pb-2 mb-2 word-break card-header"
              >
                <div class="d-flex align-center pr-2">
                  <v-icon large color="white" class="pa-2 rounded mr-4 brand-orange-background icon"
                    >mdi-newspaper-variant-outline</v-icon
                  >
                  <span class="text-left" v-html="wizardButtonLabel"></span>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </div>
          </v-card>
          <v-card
            elevation="0"
            class="text-left d-flex flex-column justify-start py-2"
            :class="isMobile ? 'full-width mb-3' : 'mb-10'"
          >
            <v-btn
              class="mx-3 d-flex justify-space-between view-button"
              color="white"
              depressed
              :class="viewFilter == keys.spot ? 'highlighted-button' : ''"
              @click="handleViewChange(keys.spot)"
            >
              <div><v-icon class="mr-2">mdi-format-list-text</v-icon>Spot communications</div>
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider class="mx-1" />
            <v-btn
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="viewFilter == keys.news ? 'highlighted-button' : ''"
              @click="handleViewChange(keys.news)"
            >
              <div><v-icon class="mr-2">mdi-newspaper-variant-outline</v-icon>News articles</div>
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider class="mx-1" />
            <v-btn
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="viewFilter == keys.alerts ? 'highlighted-button' : ''"
              @click="handleViewChange(keys.alerts)"
            >
              <div><v-icon class="mr-2">mdi-alert</v-icon>Alert communications</div>
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider class="mx-1" />
            <v-btn
              v-if="hasPermission('programs:read:admin')"
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="viewFilter == keys.program ? 'highlighted-button' : ''"
              @click="handleViewChange(keys.program)"
            >
              <div><v-icon class="mr-2">mdi-star</v-icon>Program communications</div>
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider v-if="hasPermission('programs:read:admin')" class="mx-1" />
            <v-btn
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="viewFilter == keys.library ? 'highlighted-button' : ''"
              @click="handleViewChange(keys.library)"
            >
              <div><v-icon class="mr-2">mdi-book</v-icon>Communication library</div>
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
          </v-card>
        </v-col>
        <v-col :cols="isMobile ? '12' : '8'" class="card-col">
          <v-card
            class="text-left d-flex flex-column justify-space-between py-3"
            :style="{ 'min-height': '100%' }"
            :class="isMobile ? 'full-width' : ''"
            elevation="0"
          >
            <div>
              <MessageTable
                :key="viewFilter"
                :search="search"
                :sourcePage="messageTableSource"
                :displayInfo="true"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import MessageTable from "@/components/data-table/Messages.vue";
import permissionsMixin from "@/mixins/permissionsMixin";

import { mapState } from "vuex";

export default {
  name: "CommunicationAdminV2",
  title: "Communications",
  components: {
    Header,
    MessageTable,
  },
  mixins: [permissionsMixin],
  props: {
    preload: {
      type: Number,
      defualt: null,
    },
    // Used if we came from somewhere else and immediately loaded the payments console
    previousRoute: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      keys: {
        spot: 1,
        news: 2,
        alerts: 3,
        // system: 3,
        program: 4,
        library: 5,
      },
      viewFilter: 1,
      search: null,
    };
  },
  created() {
    if (this.$route.query.tab || this.preload) {
      const tab = this.$route.query.tab || this.preload;
      if (Number(tab) == tab) this.viewFilter = Number(tab);
      else
        this.viewFilter =
          tab == "program"
            ? this.keys.program
            : tab == "news"
            ? this.keys.news
            : tab == "alerts"
            ? this.keys.alerts
            : tab == "library"
            ? this.keys.library
            : this.keys.spot;
    }
  },
  mounted() {
    //Move the fresh works help widget
    var freshworks = document.querySelector("#launcher-frame");
    if (freshworks) {
      freshworks.style.right = "-55px";
      freshworks.style["max-width"] = freshworks.style["min-width"] = "90px";
    }
  },
  unmounted() {
    var freshworks = document.querySelector("#launcher-frame");
    if (freshworks) {
      freshworks.style.right = "22px";
    }
  },
  methods: {
    handleViewChange(index) {
      this.viewFilter = index;
    },
    loadWizard() {
      this.$router.push({
        name: "communicationwizard",
        params: { previousRouteProps: { preload: this.viewFilter } },
        query: {
          previousRoute: this.$route.name,
          context: this.messageContext,
          template: this.viewFilter == this.keys.library ? 1 : 0,
        },
      });
    },
    handleSearchValueChange(val) {
      this.search = val;
    },
  },
  computed: {
    ...mapState(["userProfile", "permissions", "clients", "globalClientId"]),
    clientId: {
      get: function () {
        return this.globalClientId;
      },
      set: function (newVal) {
        this.$store.dispatch("setClientId", newVal);
      },
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    computedHeaders() {
      return [
        {
          text: "Id",
          value: "programId",
          width: "10%",
          align: this.userProfile && this.userProfile.clientId == 1 ? "start" : " d-none",
        },
        {
          text: "Program Name",
          value: "displayName",
          width: "50%",
        },
        {
          text: "Status",
          value: "status",
          width: "40%",
        },
        { text: "Details", value: "data-table-expand", width: "10%" },
      ];
    },
    messageContext() {
      if (this.viewFilter == this.keys.news) return "news";
      else if (this.viewFilter == this.keys.program) return "program";
      else if (this.viewFilter == this.keys.alerts) return "alerts";
      return "general";
    },
    messageTableSource() {
      if (this.viewFilter == this.keys.spot) return "spot-communications";
      else if (this.viewFilter == this.keys.news) return "news-communications";
      else if (this.viewFilter == this.keys.library) return "library-communications";
      else if (this.viewFilter == this.keys.program) return "program-communications";
      else if (this.viewFilter == this.keys.alerts) return "alert-communications";
      return "system-communications";
    },
    wizardButtonLabel() {
      let text;
      if (this.viewFilter == this.keys.spot) text = "spot communication";
      else if (this.viewFilter == this.keys.news) text = "news article";
      else if (this.viewFilter == this.keys.library) text = "template";
      else if (this.viewFilter == this.keys.program) text = "program communication";
      else if (this.viewFilter == this.keys.alerts) text = "alert";
      else text = "system communication";

      return `Create a new <span class="font-weight-bold">${text}</span>`;
    },
  },
  watch: {},
};
</script>

<style scoped>
.border-radius {
  border-radius: 5px;
}

/* Hides gray background when clicking v-card */
.v-card--link:before {
  background: none;
}

.card-header {
  /* max-height: 60px; */
  height: fit-content;
}

.icon {
  min-width: 52px;
  max-width: 52px;
  width: 52px;
  min-height: 52px;
  max-height: 52px;
  height: 52px;
}

.page-title {
  font-size: 1.7em;
}
@media (max-width: 960px) {
  .icon {
    min-width: 40px;
    max-width: 40px;
    width: 40px;
    min-height: 40px;
    max-height: 40px;
    height: 40px;
  }

  .page-title {
    font-size: 1.2em;
  }
}
/* Changes the default padding of all cols that have a card in them in the payment manager div */
#manager .card-col.col {
  padding-top: 8px;
  padding-bottom: 8px;
}

#manager .v-card {
  border-radius: 10px;
  padding-right: 12px;
  padding-left: 12px;
}

.view-button {
  line-height: 1.5;
  border-radius: 50px;
  height: 40px;
  margin-bottom: 16px;
  margin-top: 10px;
  padding: 0 0 0 16px !important;
}

.highlighted-button {
  background: #eeeeee !important;
}

.view-button >>> .v-btn__content {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  letter-spacing: 0;
  text-transform: none;
  line-height: 1.5;
  font-size: 16px;
}

.bold-font {
  font-family: "Roboto", sans-serif !important;
}
</style>
